#import "~/graphql/fragments/pageContent/defaultPageContent.graphql"
#import "~/graphql/fragments/pageContent/subsidyPageContent.graphql"

query getSubsidyPages(
    $site: [String!]
    $uri: [String!]
    $section: [String]
    $limit: Int
    $offset: Int
    $order: String
    $relatedTo: [QueryArgument]
    $relatedToCategories: [CategoryRelationCriteriaInput]
    $now: [QueryArgument]
) {
    entries(
        uri: $uri
        site: $site
        section: $section
        limit: $limit
        offset: $offset
        orderBy: $order
        relatedTo: $relatedTo,
        relatedToCategories: $relatedToCategories
    ) {
        __typename
        ... defaultPageContent
        ... subsidyPageContent
        ... on subsidy_Entry {
            periodsRelation(
                plainDate2: $now,
                orderBy: "plainDate2 ASC",
                limit: 1
            ) {
                id
                title
                ... on default_Entry {
                    start: plainDate @formatDateTime(format: "c", timezone: "Europe/Amsterdam")
                    end: plainDate2 @formatDateTime(format: "c", timezone: "Europe/Amsterdam")
                }
            }
        }
    }
}
